import { defineMessages } from 'react-intl';

export const uploadValidationMessages = defineMessages({
  legacyDocUnsupported: {
    defaultMessage:
      "Legacy .doc files aren't supported — please re-save as .docx or PDF.",
    id: '6lqPqHB3rJ',
    description:
      'Inline validation error when a user tries to upload a legacy Microsoft Word .doc file',
  },
  supportedFormats: {
    defaultMessage: 'PDF, DOCX, TXT, MD, JSON, XML, XLSX, ZIP, JPG, PNG (max 100MB)',
    id: 'r6FcGbLNP4',
    description:
      'Helper text under the upload dropzone listing accepted file types. .doc is deliberately excluded — the BE does not support legacy Word binaries.',
  },
});
